export default "__VITE_PUBLIC_ASSET__779e7e4d__"